import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SubBanner from "../../comm/SubBanner";
import SubMenu from "../../comm/SubMenu";

function History(props) {
  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "조합소개", sub02: "연혁" },
      });
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="intro" />

      <section className="intro section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12">
                  <h2>연혁</h2>
                  조합의 발자취와 미래 지향적 비전을 소개합니다.
                </div>
              </div>

              <div className="row pt-30">
                <div className="col-lg-3 col-md-3 col-sm-12 text-center">
                  <img
                    src="./images/img-higtory01.png"
                    alt=""
                    className="img-history"
                  />
                </div>

                <div className="col-lg-9 col-md-9 col-sm-12">
                  <div className="row">
                    <div className="col-12">
                      <h5 className="sub-title">연혁</h5>
                    </div>
                  </div>

                  <div className="row pt-10">
                    <div className="col-12">
                      <ul className="responsive-font">
                        <li>
                          <ul className="dot-style">
                            <li>1967.12.27</li>
                            <li>
                              한국자동차정비사업진흥회 강원도지부 창립
                              <br />
                              (근거 : 도로운송법 제45조 1항)
                            </li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1983.12.31</li>
                            <li>한국자동차정비사업진흥회 강원도지부 해산</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1983.07.15</li>
                            <li>
                              강원도자동차정비사업조합 창립 발기인회 개최
                              <br />
                              (근거 : 자동차관리법 제62조 및 동법 시행령
                              제184조)
                            </li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1983.09.13</li>
                            <li>강원도자동차정비사업조합 창립총회 개최</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1983.11.23</li>
                            <li>
                              강원도자동차정비사업조합 설립 허가
                              <br />
                              (강원운수 1517-1538)
                            </li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1983.12.08</li>
                            <li>춘천지방법원에 등기 (등기번호88호)</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1984.01.01</li>
                            <li>강원도자동차정비사업조합 사무 개시</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1998.04.15</li>
                            <li>조합 사옥 준공</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>1999.02.25</li>
                            <li>강원도자동차검사정비사업조합으로 명칭 변경</li>
                          </ul>
                        </li>
                        <li>
                          <ul className="dot-style">
                            <li>2023.09.13</li>
                            <li>
                              강원특별자치도자동차검사정비사업조합으로 명칭 변경
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <SubMenu id="intro" />
          </div>
        </div>
      </section>
    </>
  );
}

export default History;
